// Hooks
import { useSocialProfileAccess } from '@/utils/hooks/upsell/useSocialProfileAccess';

// Components
import Icon from '@/components/base/Icon';

export type XIconWithCrownProps = {
    className?: string;
    showCrown?: boolean;
    crownPosition?: string;
};

// Component to create X icon with crown positioned correctly
export const XIconWithCrown = ({
    className,
    showCrown = true,
    crownPosition = 'absolute -right-1 -top-1 text-xs text-icoYellow'
}: XIconWithCrownProps) => {
    const { hasAccess, isLoading } = useSocialProfileAccess({ network: 'x' });

    return (
        <div className="relative inline-block">
            <Icon
                icon="x"
                className={`${className} ${
                    hasAccess ? 'text-twitter' : 'text-icoGray-400'
                } dark:text-white`}
            />
            {!hasAccess && showCrown && !isLoading && (
                <Icon icon="crown" className={crownPosition} />
            )}
        </div>
    );
};

export default XIconWithCrown;
